module.exports = __webpack_public_path__ + "static/media/calendar.6686297c.svg";